var _path, _g, _path2, _g2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 32,
    viewBox: "0 0 39 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5249_2997",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 8,
    width: 34,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6031 25.4804L4.33062 8.89499C3.9591 8.23116 3.00967 8.22088 2.62267 8.87442L0.285205 12.8213C-0.0863127 13.4491 -0.0966212 14.2313 0.264576 14.8694L8.65982 29.7C9.3977 31.002 10.7754 31.815 12.277 31.8305L29.3513 32.0003C30.084 32.0054 30.7651 31.6246 31.1418 30.9917L33.4793 27.0499C33.8663 26.3963 33.3967 25.573 32.6382 25.5679L13.6031 25.4804Z",
    fill: "#6466F1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5249_2997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6031 25.4804L4.33062 8.89499C3.9591 8.23116 3.00967 8.22088 2.62267 8.87442L0.285205 12.8213C-0.0863127 13.4491 -0.0966212 14.2313 0.264576 14.8694L8.65982 29.7C9.3977 31.002 10.7754 31.815 12.277 31.8305L29.3513 32.0003C30.084 32.0054 30.7651 31.6246 31.1418 30.9917L33.4793 27.0499C33.8663 26.3963 33.3967 25.573 32.6382 25.5679L13.6031 25.4804Z",
    fill: "#6466F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0314 31.1315C27.5066 31.1315 34.3772 24.2796 34.3772 15.8275C34.3772 7.37528 27.5066 0.523438 19.0314 0.523438C10.5562 0.523438 3.68567 7.37528 3.68567 15.8275C3.68567 24.2796 10.5562 31.1315 19.0314 31.1315Z",
    fill: "url(#paint0_radial_5249_2997)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5249_2997",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 28,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9128 9.62043L29.5371 1.88094C28.9437 0.836317 27.8395 0.182778 26.6321 0.172486L10.017 0.0078125L13.7115 6.40936L22.9169 6.50199L24.8364 6.52258L25.7755 8.18986L30.2905 16.1815H37.6228L33.9128 9.62558V9.62043Z",
    fill: "#6466F1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5249_2997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9128 9.62043L29.5371 1.88094C28.9437 0.836317 27.8395 0.182778 26.6321 0.172486L10.017 0.0078125L13.7115 6.40936L22.9169 6.50199L24.8364 6.52258L25.7755 8.18986L30.2905 16.1815H37.6228L33.9128 9.62558V9.62043Z",
    fill: "#6466F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0314 31.1315C27.5066 31.1315 34.3772 24.2796 34.3772 15.8275C34.3772 7.37528 27.5066 0.523438 19.0314 0.523438C10.5562 0.523438 3.68567 7.37528 3.68567 15.8275C3.68567 24.2796 10.5562 31.1315 19.0314 31.1315Z",
    fill: "url(#paint1_radial_5249_2997)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2987 17.3677C38.5722 17.8514 38.567 18.4484 38.2832 18.9321L37.5608 20.1568L36.5443 21.8704C36.276 22.3181 35.791 22.596 35.2646 22.5909L15.4246 22.3902L5.67224 5.16155C5.41424 4.70871 5.41942 4.1478 5.68774 3.70011L7.18411 1.16831C7.61754 0.437589 8.41219 -0.0101182 9.26359 0.000173704L10.0118 0.0104756L13.7063 6.41203L18.2264 14.414L19.1707 16.071L21.0851 16.0915L30.2853 16.1842H37.6176L38.2936 17.378L38.2987 17.3677Z",
    fill: "#6466F1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5249_2997",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.9915 16.6068) scale(15.3892 15.3474)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5249_2997",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.9915 16.6068) scale(15.3892 15.3474)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logoIcon.2913f98027c87ca7de26d7933395741e.svg";
export { ForwardRef as ReactComponent };